import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { SubscriptionPrompt } from '../SubscriptionPrompt';

export function AppLayout() {
  return (
    <div className="flex min-h-screen bg-background">
      {/* Noise texture overlay */}
      <div className="noise-overlay" />
      
      {/* Sidebar */}
      <Sidebar />

      {/* Main content */}
      <main className="flex-1 flex flex-col min-w-0">
        <Outlet />
      </main>
      
      {/* Subscription Prompt - shows when trial/subscription expires */}
      <SubscriptionPrompt />
    </div>
  );
}
